import { NgModule, Optional, SkipSelf } from '@angular/core';

import { LivechatService } from './livechat.service';

@NgModule({
  providers: [LivechatService],
})
export class LivechatModule {
  constructor(
    private livechatService: LivechatService,
    @Optional() @SkipSelf() parentModule?: LivechatModule
  ) {
    if (parentModule) {
      throw new Error('LivechatModule is already loaded. Import it in the AppModule only');
    }
    this.livechatService.init();
  }
}
